export class GmapsPoint {
  latitude: number;
  longitude: number;

  constructor(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-point.model.ts